import { motion } from "motion/react";

export const Typed: React.FC<{ children: string }> = ({ children }) => {
  return (
    <motion.span exit={{ opacity: 0 }}>
      {children.split("").map((char, index) => (
        <motion.span
          key={index}
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          transition={{
            delay: index / 20,
          }}
        >
          {char}
        </motion.span>
      ))}
    </motion.span>
  );
};
